/**
 * Display labels for XML formats and Factur-X profiles — shared by the
 * generator's format selector and the pre-send confirmation summary
 * (`XMLInsights-SDD` `REQ-TESTDATA-011`) so both always show the same name.
 */
export const XML_FORMAT_LABELS: Record<string, string> = {
  sales005: 'SALES005',
  ubl21: 'UBL 2.1',
  cii: 'CII',
  facturx: 'Factur-X',
}

export const FACTURX_PROFILE_LABELS: Record<string, string> = {
  minimum: 'MINIMUM',
  basic_wl: 'BASIC WL',
  basic: 'BASIC',
  en16931: 'EN 16931',
  extended: 'EXTENDED',
}
